// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"379":"354cc8f8478b72f5","794":"8ab02d70d598f6da","6076":"e63c663bd407daba","8411":"404630b293923a34","8567":"c41239cdbbbb9872"}[chunkId] + ".js";
};